import Swal from 'sweetalert2/src/sweetalert2'
import '@sweetalert2/themes/dark/dark.css';


export function createPerson(pers) {
    if (pers.name != undefined) {
        return createTraitor(pers);
    }
    var lastName = document.createElement('div');
    lastName.innerHTML = "<p><span class=\"fieldName\">Прізвище: </span>" + pers.lastName +
        "<br><span class=\"fieldName\">Ім'я: </span>" + pers.firstName +
        "<br><span class=\"fieldName\">По батькові: </span>" + pers.middleName +
        "<p><span class=\"fieldName\">Дата народження: </span>" + pers.bDate +
        "<br><span class=\"fieldName\">Місце народження: </span>" + pers.bLocation +
        "<p><span class=\"fieldName\">Громадянин: </span>" + pers.citizen +
        "<br><span class=\"fieldName\">Національність: </span>" + pers.nationality +
        "<br><span class=\"fieldName\">Раніше засуджений: </span>" + pers.criminal +
        "<p><span class=\"fieldName\">Кличка: </span>" + pers.nikName +
        "<p><span class=\"fieldName\">Описання особи: </span>" + pers.desc


    return (lastName);
}

export function createTraitor(pers) {
    var lastName = document.createElement('div');
    lastName.innerHTML = "<p><span class=\"fieldName\">ПІБ: </span>" + pers.nameTraitor +
        "<br><span class=\"fieldName\">Дата народження: </span>" + pers.bdate +
        "<br><span class=\"fieldName\">Адреса: </span>" + pers.adres +
        "<p><span class=\"fieldName\">Телефон: </span>" + pers.phone +
        "<br><span class=\"fieldName\">ІПН: </span>" + pers.ipn +
        "<p><span class=\"fieldName\">Документи: </span>" + pers.docs +
        "<br><span class=\"fieldName\">Посилання: </span>" + pers.link +
        "<br><span class=\"fieldName\">Родина: </span>" + pers.rel


    return (lastName);
}

export function createAddress(addr) {
    var lastName = document.createElement('div');
    lastName.innerHTML =
        "<p><span class=\"fieldName\">Регіон: </span>" + addr.region +
        "<br><span class=\"fieldName\">Адмін-територіальна одиниця: </span>" + addr.ato +
        "<p><span class=\"fieldName\">НП (район міста): </span>" + addr.np +
        "<br><span class=\"fieldName\">Вулиця: </span>" + addr.street +
        "<br><span class=\"fieldName\">Будинок: </span>" + addr.buiding +
        "<br><span class=\"fieldName\">Квартира: </span>" + addr.flat +
        "<p><span class=\"fieldName\">Опис: </span>" + addr.descAddress
    return (lastName);
}

export function createAuto(auto) {
    var t = "<p align=\"left\">" + auto.model + " " + auto.number + " " + auto.color;
    var lastName = document.createElement('div');
    lastName.innerHTML =
        "<p><span class=\"fieldName\">Марка: </span>" + auto.model +
        "<br><span class=\"fieldName\">Номер: </span>" + auto.number +
        "<br><span class=\"fieldName\">Колір: </span>" + auto.color +
        "<p><span class=\"fieldName\">Опис: </span>" + auto.descAuto +
        "</div>"


    return (lastName);
}

export function createCompany(company) {
    var t = "<p align=\"left\">" + company.nameCompany + " " + company.activity + " " + company.orpo;
    var lastName = document.createElement('div');
    lastName.innerHTML =

        "<p><span class=\"fieldName\">Назва: </span>" + company.nameCompany +
        "<br><span class=\"fieldName\">Діяльність: </span>" + company.activity +
        "<br><span class=\"fieldName\">ОРПО: </span>" + company.orpo +

        "</div>"


    return (lastName);
}

export function createContact(contact) {


    var lastName = document.createElement('div');
    lastName.innerHTML = "<p><span class=\"fieldName\">" + contact.contactKey + ": </span>" + contact.contactValue;
    return (lastName);
}

export function createDoc(doc) {
    var t = "<p align=\"left\">- " + doc.typeDocument + " " + doc.seriaDocument + " " + doc.numberDocument;
    var lastName = document.createElement('div');
    lastName.innerHTML =
        "<p><span class=\"fieldName\">Тип: </span>" + doc.typeDocument +
        "<br><span class=\"fieldName\">Серія: </span>" + doc.seriaDocument +
        "<br><span class=\"fieldName\">Номер: </span>" + doc.numberDocument +
        "<br><span class=\"fieldName\">Опис: </span>" + doc.descDocument +
        "</div>"


    return (lastName);
}

export function createGun(gun) {
    var t = "<p align=\"left\">" + gun.typeGun + " " + gun.numberGun;
    var lastName = document.createElement('div');
    lastName.innerHTML =
        "<p><span class=\"fieldName\">Тип: </span>" + gun.typeGun +
        "<br><span class=\"fieldName\">Номер: </span>" + gun.numberGun +
        "<br><span class=\"fieldName\">Опис: </span>" + gun.descGun +
        "</div>"


    return (lastName);
}

export function createProceedings(proceedings) {
    var t = "<p align=\"left\">" + proceedings.typeProceedings + " " + proceedings.numberProceedings;
    var lastName = document.createElement('div');
    lastName.innerHTML =
        "<p><span class=\"fieldName\">Тип: </span>" + proceedings.typeProceedings +
        "<br><span class=\"fieldName\">Номер: </span>" + proceedings.numberProceedings +
        "<br><span class=\"fieldName\">Дата: </span>" + proceedings.dateProceedings +
        (proceedings.fabulaProceedings == undefined ? "" : "<br><span class=\"fieldName\">Фабула: </span>" + proceedings.fabulaProceedings) +
        "</div>"


    return (lastName);
}

export function createOPM(opm) {

    var t = "<p align=\"left\">" + opm.numberOPM + " " + opm.dateOPM + " " + opm.typeExecutor + " ";
    if (opm.executor != undefined) t += opm.executor;
    t += "<br>";
    if (opm.ini_organ != undefined) t += opm.ini_organ + " ";
    if (opm.ini_name != undefined) t += opm.ini_name + " ";
    if (opm.ini_direction != undefined) t += opm.ini_direction;
    var lastName = document.createElement('div');
    lastName.innerHTML =
        " <p><span class=\"fieldName\">Номер: </span>" + opm.numberOPM +
        "<br><span class=\"fieldName\">Дата: </span>" + opm.dateOPM +
        "<p><span class=\"fieldName\">Підрозділ виконавця: </span>" + opm.typeExecutor +
        "<br><span class=\"fieldName\">Виконавець: </span>" + opm.executor +
        "<p><span class=\"fieldName\">Підрозділ ініціатора: </span>" + opm.ini_organ +
        "<br><span class=\"fieldName\">Відділ ініціатора: </span>" + opm.ini_direction +
        "<br><span class=\"fieldName\">Ініціатор: </span>" + opm.ini_name +
        "<br><span class=\"fieldName\">Зберігання: </span>" + opm.storage +

        ((opm.proceedings != undefined) ?
            ((opm.proceedings.id == -1) ? "" : ("<br><br>" + "<p><span>" + opm.proceedings.typeProceedings + " </span>" + opm.proceedings.numberProceedings +
                "<br><span class=\"fieldName\">Дата: </span>" + opm.proceedings.dateProceedings)) +
            ((opm.proceedings.fabulaProceedings == undefined) ? "" : ("<br><span class=\"fieldName\">Фабула: </span>" + opm.proceedings.fabulaProceedings))
            : "")




    return (lastName);
}

export function createBS(bs) {
    var t = "<p align=\"left\">LAC: " + bs.lac + " CID: " + bs.cid + "<br>Азимут: " + bs.az + "°<br>" + bs.address;;
    var lastName = document.createElement('div');
    lastName.innerHTML =
        "<p><span class=\"fieldName\">LAC: </span>" + bs.lac +
        "<br><span class=\"fieldName\">CID: </span>" + bs.cid +
        "<br><span class=\"fieldName\">Азимут: </span>" + bs.az +
        "<br><span class=\"fieldName\">Адреса: </span>" + bs.address +
        "<p><span class=\"fieldName\">Опис: </span>" + bs.descBS +
        ((bs.mnc == 1 && bs.mcc == 255) ? "<p><span class=\"fieldName\">Оператор: </span>Водафон" : ((bs.mnc == 3 && bs.mcc == 255) ? "<p><span class=\"fieldName\">Оператор: </span>Київстар" : ((bs.mnc == 6 && bs.mcc == 255) ? "<p><span class=\"fieldName\">Оператор: </span>Lifecell" : ""))) +
        ((bs.mcc == 255) ? "<br><span class=\"fieldName\">Країна: </span>Україна" : ((bs.mcc == 250) ? "<br><span class=\"fieldName\">Країна: </span>Тупих дебілів" :  "<br><span class=\"fieldName\">Країна: </span>"+bs.mcc)) +
        (bs.band == undefined ? "" : "<p><span class=\"fieldName\">Потужність: </span>" + bs.band) +
        (bs.lat == undefined && bs.lon == undefined ? "" : "<p><span class=\"fieldName\">Координати: </span>" +bs.lat + " "+bs.lon) +
        "</div>"


    return (lastName);
}

export function createKan(bs) {
    var lastName = document.createElement('div');
    lastName.innerHTML =
        "<p><span class=\"fieldName\">Шифр: </span>" + bs.shifrKan +
        "<br><span class=\"fieldName\">Номер телефона: </span>" + bs.lineKan +
        "<p><span class=\"fieldName\">Дата надходження: </span>" + bs.dateComingsKan +
        "<p><span class=\"fieldName\">Дата початку контролю: </span>" + bs.dateBeginKan +
        "<br><span class=\"fieldName\">Дата кінця контролю: </span>" + bs.dateEndKan +
        "<p><span class=\"fieldName\">Адреса: </span>" + bs.addressKan +
        "<br><span class=\"fieldName\">Місце роботи: </span>" + bs.jobKan +
        "<p><span class=\"fieldName\">Опис: </span>" + bs.descKan +
        "</div>"


    return (lastName);
}

export function createPersonCollapsed(pers, i, type, text, text1, text2) {
    var img = "/static/media/profile.feab64b5f4abab6d98ba.png"
    if (pers.image !== undefined) {
        img = "/static/media/loading.5e2c629f063410d4b0c2.gif"
    }
    var t = "<p align=\"left\">" + pers.lastName + " " + pers.firstName + " " + pers.middleName + "<br>" + pers.bDate + "   " + pers.citizen + ((text == undefined) ? "" : "<br>" + text);
    var lastName = document.createElement('div');
    lastName.innerHTML = "<table style=\"margin-top: 0px;\"><tr>" +
        "<td style=\"vertical-align: middle\"><table border=1 height=\"auto\"  style=\"margin-top: 0px;\"><tr>" +
        "<td><font size=\"3px\">" + ((type == 2 || (type == 3)) ? text1 : "&nbsp;&nbsp;&nbsp;") + "</font></td>" +
        "<td><font size=\"3px\">" + ((type == 1 || (type == 3)) ? text2 : "&nbsp;&nbsp;&nbsp;") + "</font></td></tr></table></td>"
        + "<td style=\"vertical-align: middle\"><div><img class=\"prevImageSearch\" id=\"image" + pers.image + "\" src=\"" + img + "\"></div></td>"
        + "<td style=\"vertical-align: middle\">" +
        "<div id = \"persh" + i + "\" style=\"margin-left: 20px; margin-right:20px\" onclick=\"" +
        "if(document.getElementById('persb" + i + "').style.display == 'none'){" +
        "document.getElementById('persb" + i + "').style.display = 'block'" +
        "}else{" +
        "document.getElementById('persb" + i + "').style.display = 'none'" +
        "}" +
        "\">" + t + "</div></td></tr></table>" +

        "<div id = \"persb" + i + "\" style=\"margin-left: 20px; margin-right:20px; display: none\">" +
        " <p><span class=\"fieldName\">Прізвище: </span>" + pers.lastName +
        "<br><span class=\"fieldName\">Ім'я: </span>" + pers.firstName +
        "<br><span class=\"fieldName\">По батькові: </span>" + pers.middleName +
        " <p><span class=\"fieldName\">Дата народження: </span>" + pers.bDate +
        "<br><span class=\"fieldName\">Місце народження: </span>" + pers.bLocation +
        "<p><span class=\"fieldName\">Громадянин: </span>" + pers.citizen +
        "<br><span class=\"fieldName\">Національність: </span>" + pers.nationality +
        "<br><span class=\"fieldName\">Раніше засуджений: </span>" + pers.criminal +
        "<p><span class=\"fieldName\">Описання особи: </span>" + pers.desc +
        "</div>"


    return (lastName);
}

export function createTraitorCollapsed(pers, i, type, text, text1, text2) {
    var img = "/static/media/profile.feab64b5f4abab6d98ba.png"
    if (pers.image !== undefined) {
        img = "data:image/png;base64," + pers.image
    }
    var t = "<p align=\"left\">" + pers.nameTraitor + "<br>" + pers.bdate;
    var lastName = document.createElement('div');
    lastName.innerHTML = "<table style=\"margin-top: 0px;\"><tr>" +
        "<td style=\"vertical-align: middle\"><table border=1 height=\"auto\"  style=\"margin-top: 0px;\"><tr>" +
        "<td><font size=\"3px\">" + ((type == 2 || (type == 3)) ? text1 : "&nbsp;&nbsp;&nbsp;") + "</font></td>" +
        "<td><font size=\"3px\">" + ((type == 1 || (type == 3)) ? text2 : "&nbsp;&nbsp;&nbsp;") + "</font></td></tr></table></td><td style=\"vertical-align: middle\">" +
        "<td style=\"vertical-align: middle\"><div><img class=\"prevImageSearch\" src=\"" + img + "\"></div></td>" +
        "<div id = \"persh" + i + "\" style=\"margin-left: 20px; margin-right:20px\" onclick=\"" +
        "if(document.getElementById('traitorsb" + i + "').style.display == 'none'){" +
        "document.getElementById('traitorsb" + i + "').style.display = 'block'" +
        "}else{" +
        "document.getElementById('traitorsb" + i + "').style.display = 'none'" +
        "}" +
        "\">" + t + "</div></td></tr></table>" +
        "<div id = \"traitorsb" + i + "\" style=\"margin-left: 20px; margin-right:20px; display: none\">" +
        "<p><span class=\"fieldName\">ПІБ: </span>" + pers.nameTraitor +
        "<br><span class=\"fieldName\">Дата народження: </span>" + pers.bdate +
        "<br><span class=\"fieldName\">Адреса: </span>" + pers.adres +
        "<p><span class=\"fieldName\">Телефон: </span>" + pers.phone +
        "<br><span class=\"fieldName\">ІПН: </span>" + pers.ipn +
        "<p><span class=\"fieldName\">Документи: </span>" + pers.docs +
        "<br><span class=\"fieldName\">Посилання: </span>" + pers.link +
        "<br><span class=\"fieldName\">Родина: </span>" + pers.rel +


        "</div>"


    return (lastName);
}

export function createAddressCollapsed(addr, i, type, text, text1, text2) {
    var t = "<p align=\"left\">" + addr.region + " " + addr.ato + " " + addr.np + "   " + addr.street + " " + addr.buiding + " " + addr.flat + ((text == undefined) ? "" : "<br>" + text);
    var lastName = document.createElement('div');
    lastName.innerHTML = "<table style=\"margin-top: 0px;\"><tr>" +
        "<td style=\"vertical-align: middle\"><table border=1 height=\"auto\"  style=\"margin-top: 0px;\"><tr>" +
        "<td><font size=\"3px\">" + ((type == 2 || (type == 3)) ? text1 : "&nbsp;&nbsp;&nbsp;") + "</font></td>" +
        "<td><font size=\"3px\">" + ((type == 1 || (type == 3)) ? text2 : "&nbsp;&nbsp;&nbsp;") + "</font></td></tr></table></td><td style=\"vertical-align: middle\">" +
        "<div id = \"adrh" + i + "\" style=\"margin-left: 20px; margin-right:20px\" onclick=\"" +
        "if(document.getElementById('adrb" + i + "').style.display == 'none'){" +
        "document.getElementById('adrb" + i + "').style.display = 'block'" +
        "}else{" +
        "document.getElementById('adrb" + i + "').style.display = 'none'" +
        "}" +
        "\">" + t + "</div></td></tr></table>" +
        "<div id = \"adrb" + i + "\" style=\"margin-left: 20px; margin-right:20px; display: none\">" +
        ((text == undefined) ? "" : "<br><span class=\"fieldName\">Інформаія: </span>" + text) +
        "<p><span class=\"fieldName\">Регіон: </span>" + addr.region +
        "<br><span class=\"fieldName\">Адмін-територіальна одиниця: </span>" + addr.ato +
        "<p><span class=\"fieldName\">НП (район міста): </span>" + addr.np +
        "<br><span class=\"fieldName\">Вулиця: </span>" + addr.street +
        "<br><span class=\"fieldName\">Будинок: </span>" + addr.buiding +
        "<br><span class=\"fieldName\">Квартира: </span>" + addr.flat +
        "<p><span class=\"fieldName\">Опис: </span>" + addr.descAddress +
        "</div>"


    return (lastName);
}

export function createAutoCollapsed(auto, i, type, text, text1, text2) {
    var t = "<p align=\"left\">" + auto.model + " " + auto.number + " " + auto.color;
    var lastName = document.createElement('div');
    lastName.innerHTML = "<table style=\"margin-top: 0px;\"><tr>" +
        "<td style=\"vertical-align: middle\"><table border=1 height=\"auto\"  style=\"margin-top: 0px;\"><tr>" +
        "<td><font size=\"3px\">" + ((auto.type == 2 || (auto.type == 3)) ? text1 : "&nbsp;&nbsp;&nbsp;") + "</font></td>" +
        "<td><font size=\"3px\">" + ((auto.type == 1 || (auto.type == 3)) ? text2 : "&nbsp;&nbsp;&nbsp;") + "</font></td></tr></table></td><td style=\"vertical-align: middle\">" +
        "<div id = \"autoh" + i + "\" style=\"margin-left: 20px; margin-right:20px\" onclick=\"" +
        "if(document.getElementById('autob" + i + "').style.display == 'none'){" +
        "document.getElementById('autob" + i + "').style.display = 'block'" +
        "}else{" +
        "document.getElementById('autob" + i + "').style.display = 'none'" +
        "}" +
        "\">" + t + "</div></td></tr></table>" +
        "<div id = \"autob" + i + "\" style=\"margin-left: 20px; margin-right:20px; display: none\">" +
        "<p><span class=\"fieldName\">Марка: </span>" + auto.model +
        "<br><span class=\"fieldName\">Номер: </span>" + auto.number +
        "<br><span class=\"fieldName\">Колір: </span>" + auto.color +
        "<p><span class=\"fieldName\">Опис: </span>" + auto.descAuto +
        ((auto.infoAuto != undefined) ? "<br><span class=\"fieldName\">Довідка: </span>" + auto.infoAuto.replace(/\r\n/g, "<p>") : "") +
        "</div>"


    return (lastName);
}

export function createCompanyCollapsed(company, i, text1, text2) {
    var t = "<p align=\"left\">" + company.nameCompany + " " + company.activity + " " + company.orpo;
    var lastName = document.createElement('div');
    lastName.innerHTML = "<table style=\"margin-top: 0px;\"><tr>" +
        "<td style=\"vertical-align: middle\"><table border=1 height=\"auto\"  style=\"margin-top: 0px;\"><tr>" +
        "<td><font size=\"3px\">" + ((company.type == 2 || (company.type == 3)) ? text1 : "&nbsp;&nbsp;&nbsp;") + "</font></td>" +
        "<td><font size=\"3px\">" + ((company.type == 1 || (company.type == 3)) ? text2 : "&nbsp;&nbsp;&nbsp;") + "</font></td></tr></table></td><td style=\"vertical-align: middle\">" +
        "<div id = \"cmph" + i + "\" style=\"margin-left: 20px; margin-right:20px\" onclick=\"" +
        "if(document.getElementById('cmpb" + i + "').style.display == 'none'){" +
        "document.getElementById('cmpb" + i + "').style.display = 'block'" +
        "}else{" +
        "document.getElementById('cmpb" + i + "').style.display = 'none'" +
        "}" +
        "\">" + t + "</div></td></tr></table>" +
        "<div id = \"cmpb" + i + "\" style=\"margin-left: 20px; margin-right:20px; display: none\">" +
        "<p><span class=\"fieldName\">Назва: </span>" + company.nameCompany +
        "<br><span class=\"fieldName\">Діяльність: </span>" + company.activity +
        "<br><span class=\"fieldName\">ОРПО: </span>" + company.orpo +
        "<br><span class=\"fieldName\">Довідка: </span>" + company.infoCompany.replace(/\r\n/g, "<p>") +
        "</div>"


    return (lastName);
}

export function createContactCollapsed(contact, type, text, text1, text2) {
    if (contact.contact == undefined) {
        var t = "<p align=\"left\"><span class=\"fieldName\">" + contact.obj.contactKey + ": </span>" + contact.obj.contactValue + ((contact.text != undefined) ? "<br>" + contact.text : "");
        var lastName = document.createElement('div');
        lastName.innerHTML = "<table style=\"margin-top: 0px;\"><tr>" +
            "<td style=\"vertical-align: middle\"><table border=1 height=\"auto\"  style=\"margin-top: 0px;\"><tr>" +
            "<td><font size=\"3px\">" + ((contact.type == 2 || (contact.type == 3)) ? text1 : "&nbsp;&nbsp;&nbsp;") + "</font></td>" +
            "<td><font size=\"3px\">" + ((contact.type == 1 || (contact.type == 3)) ? text2 : "&nbsp;&nbsp;&nbsp;") + "</font></td></tr></table></td><td style=\"vertical-align: middle\">" +

            t + "</div></td></tr></table>";



        return (lastName);
    }
    var t = "<p align=\"left\"><span class=\"fieldName\">" + contact.contact.contactKey + ": </span>" + contact.contact.contactValue + ((contact.text != undefined) ? "<br>" + contact.text : "");
    var lastName = document.createElement('div');
    lastName.innerHTML = "<table style=\"margin-top: 0px;\"><tr>" +
        "<td style=\"vertical-align: middle\"><table border=1 height=\"auto\"  style=\"margin-top: 0px;\"><tr>" +
        "<td><font size=\"3px\">" + ((contact.type == 2 || (contact.type == 3)) ? "З" : "&nbsp;&nbsp;&nbsp;") + "</font></td>" +
        "<td><font size=\"3px\">" + ((contact.type == 1 || (contact.type == 3)) ? "О" : "&nbsp;&nbsp;&nbsp;") + "</font></td></tr></table></td><td style=\"vertical-align: middle\">" +

        t + "</div></td></tr></table>";



    return (lastName);
}

export function createGunCollapsed(gun, i) {
    var t = "<p align=\"left\">- " + gun.typeGun + " " + gun.numberGun;
    var lastName = document.createElement('div');
    lastName.innerHTML = "<div id = \"gunh" + i + "\" style=\"margin-left: 20px; margin-right:20px\" onclick=\"" +
        "if(document.getElementById('gunb" + i + "').style.display == 'none'){" +
        "document.getElementById('gunb" + i + "').style.display = 'block'" +
        "}else{" +
        "document.getElementById('gunb" + i + "').style.display = 'none'" +
        "}" +
        "\">" + t + "</div>" +
        "<div id = \"gunb" + i + "\" style=\"margin-left: 20px; margin-right:20px; display: none\">" +
        "<p><span class=\"fieldName\">Тип: </span>" + gun.typeGun +
        "<br><span class=\"fieldName\">Номер: </span>" + gun.numberGun +
        "<br><span class=\"fieldName\">Опис: </span>" + gun.descGun +
        "</div>"


    return (lastName);
}

export function createDocCollapsed(doc, i) {
    var t = "<p align=\"left\">- " + doc.typeDocument + " " + doc.seriaDocument + " " + doc.numberDocument;
    var lastName = document.createElement('div');
    lastName.innerHTML = "<div id = \"doch" + i + "\" style=\"margin-left: 20px; margin-right:20px\" onclick=\"" +
        "if(document.getElementById('docb" + i + "').style.display == 'none'){" +
        "document.getElementById('docb" + i + "').style.display = 'block'" +
        "}else{" +
        "document.getElementById('docb" + i + "').style.display = 'none'" +
        "}" +
        "\">" + t + "</div>" +
        "<div id = \"docb" + i + "\" style=\"margin-left: 20px; margin-right:20px; display: none\">" +
        "<p><span class=\"fieldName\">Тип: </span>" + doc.typeDocument +
        "<br><span class=\"fieldName\">Серія: </span>" + doc.seriaDocument +
        "<br><span class=\"fieldName\">Номер: </span>" + doc.numberDocument +
        "<br><span class=\"fieldName\">Опис: </span>" + doc.descDocument +
        "</div>"


    return (lastName);
}

export function createArchCollapsed(arch, i) {
    var a = arch.archive
    if (a == undefined) {
        a = arch.obj
    }


    var lastName = document.createElement('div');
    lastName.innerHTML = "<p>" + a.fileName + ((arch.text != undefined) ? "<br>" + arch.text : "") + ((a.text != undefined) ? "<br>" + a.text : "")
        ;

    return (lastName);
}

export function createOPMCollapsed(opm, i, type, text, text1, text2) {
    var t = "<p align=\"left\">" + opm.numberOPM + " " + opm.dateOPM + " " + opm.typeExecutor + " ";
    if (opm.executor != undefined) t += opm.executor;
    t += "<br>";
    if (opm.ini_organ != undefined) t += opm.ini_organ + " ";
    if (opm.ini_name != undefined) t += opm.ini_name + " ";
    if (opm.ini_direction != undefined) t += opm.ini_direction;
    t += "<br>";
    if (opm.text != undefined) t += text;
    var lastName = document.createElement('div');
    lastName.innerHTML = "<table style=\"margin-top: 0px;\"><tr>" +
        "<td style=\"vertical-align: middle\"><table border=1 height=\"auto\"  style=\"margin-top: 0px;\"><tr>" +
        "<td><font size=\"3px\">" + ((type == 2 || (type == 3)) ? text1 : "&nbsp;&nbsp;&nbsp;") + "</font></td>" +
        "<td><font size=\"3px\">" + ((type == 1 || (type == 3)) ? text2 : "&nbsp;&nbsp;&nbsp;") + "</font></td></tr></table></td><td style=\"vertical-align: middle\">" +
        "<div id = \"opmh" + i + "\" style=\"margin-left: 20px; margin-right:20px\" onclick=\"" +
        "if(document.getElementById('opmb" + i + "').style.display == 'none'){" +
        "document.getElementById('opmb" + i + "').style.display = 'block'" +
        "}else{" +
        "document.getElementById('opmb" + i + "').style.display = 'none'" +
        "}" +
        "\">" + t + "</div></td></tr></table>" +
        "<div id = \"opmb" + i + "\" style=\"margin-left: 20px; margin-right:20px; display: none\">" +
        " <p><span class=\"fieldName\">Номер: </span>" + opm.numberOPM +
        "<br><span class=\"fieldName\">Дата: </span>" + opm.dateOPM +
        "<p><span class=\"fieldName\">Підрозділ виконавця: </span>" + opm.typeExecutor +
        "<br><span class=\"fieldName\">Виконавець: </span>" + opm.executor +
        "<p><span class=\"fieldName\">Підрозділ ініціатора: </span>" + opm.ini_organ +
        "<br><span class=\"fieldName\">Відділ ініціатора: </span>" + opm.ini_direction +
        "<br><span class=\"fieldName\">Ініціатор: </span>" + opm.ini_name +
        "<br><span class=\"fieldName\">Зберігання: </span>" + opm.storage +

        ((opm.proceedings != undefined) ?
            ((opm.proceedings.id == -1) ? "" : ("<br><br>" + "<p><span>" + opm.proceedings.typeProceedings + " </span>" + opm.proceedings.numberProceedings +
                "<br><span class=\"fieldName\">Дата: </span>" + opm.proceedings.dateProceedings)) +
            ((opm.proceedings.fabulaProceedings == undefined) ? "" : ("<br><span class=\"fieldName\">Фабула: </span>" + opm.proceedings.fabulaProceedings))
            : "") +

        "</div>"


    return (lastName);
}

export function createBSCollapsed(bs, i, type, text, text1, text2) {
    var t = "<p align=\"left\">LAC: " + bs.lac + " CID: " + bs.cid + "<br>Азимут: " + bs.az + "°<br>" + bs.address + ((text == undefined) ? "" : "<br>" + text);
    var lastName = document.createElement('div');
    lastName.innerHTML =
        "<p><span class=\"fieldName\">LAC: </span>" + bs.lac +
        "<br><span class=\"fieldName\">CID: </span>" + bs.cid +
        "<br><span class=\"fieldName\">Азимут: </span>" + bs.az +
        "<br><span class=\"fieldName\">Адреса: </span>" + bs.address +
        "<p><span class=\"fieldName\">Опис: </span>" + bs.descBS +
        ((bs.mnc == 1 && bs.mcc == 255) ? "<p><span class=\"fieldName\">Оператор: </span>Водафон" : ((bs.mnc == 3 && bs.mcc == 255) ? "<p><span class=\"fieldName\">Оператор: </span>Київстар" : ((bs.mnc == 6 && bs.mcc == 255) ? "<p><span class=\"fieldName\">Оператор: </span>Lifecell" : ""))) +
        ((bs.mcc == 255) ? "<br><span class=\"fieldName\">Країна: </span>Україна" : ((bs.mcc == 250) ? "<br><span class=\"fieldName\">Країна: </span>Тупих дебілів" :  "<br><span class=\"fieldName\">Країна: </span>"+bs.mcc)) +
        (bs.band == undefined ? "" : "<p><span class=\"fieldName\">Потужність: </span>" + bs.band) +
        (bs.lat == undefined && bs.lon == undefined ? "" : "<p><span class=\"fieldName\">Координати: </span>" +bs.lat + " "+bs.lon) +
        "</div>"

    var lastName = document.createElement('div');
    lastName.innerHTML = "<table style=\"margin-top: 0px;\"><tr>" +
        "<td style=\"vertical-align: middle\"><table border=1 height=\"auto\"  style=\"margin-top: 0px;\"><tr>" +
        "<td><font size=\"3px\">" + ((type == 2 || (type == 3)) ? text1 : "&nbsp;&nbsp;&nbsp;") + "</font></td>" +
        "<td><font size=\"3px\">" + ((type == 1 || (type == 3)) ? text2 : "&nbsp;&nbsp;&nbsp;") + "</font></td></tr></table></td><td style=\"vertical-align: middle\">" +
        "<div id = \"bsh" + i + "\" style=\"margin-left: 20px; margin-right:20px\" onclick=\"" +
        "if(document.getElementById('bsb" + i + "').style.display == 'none'){" +
        "document.getElementById('bsb" + i + "').style.display = 'block'" +
        "}else{" +
        "document.getElementById('bsb" + i + "').style.display = 'none'" +
        "}" +
        "\">" + t + "</div></td></tr></table>" +
        "<div id = \"bsb" + i + "\" style=\"margin-left: 20px; margin-right:20px; display: none\">" +
        "<p><span class=\"fieldName\">LAC: </span>" + bs.lac +
        "<br><span class=\"fieldName\">CID: </span>" + bs.cid +
        "<br><span class=\"fieldName\">Азимут: </span>" + bs.az +
        "<br><span class=\"fieldName\">Адреса: </span>" + bs.address +
        "<p><span class=\"fieldName\">Опис: </span>" + bs.descBS +
        ((bs.mnc == 1 && bs.mcc == 255) ? "<p><span class=\"fieldName\">Оператор: </span>Водафон" : ((bs.mnc == 3 && bs.mcc == 255) ? "<p><span class=\"fieldName\">Оператор: </span>Київстар" : ((bs.mnc == 6 && bs.mcc == 255) ? "<p><span class=\"fieldName\">Оператор: </span>Lifecell" : ""))) +
        ((bs.mcc == 255) ? "<br><span class=\"fieldName\">Країна: </span>Україна" : ((bs.mcc == 250) ? "<br><span class=\"fieldName\">Країна: </span>Тупих дебілів" :  "<br><span class=\"fieldName\">Країна: </span>"+bs.mcc)) +
        (bs.band == undefined ? "" : "<p><span class=\"fieldName\">Потужність: </span>" + bs.band) +
        (bs.lat == undefined && bs.lon == undefined ? "" : "<p><span class=\"fieldName\">Координати: </span>" +bs.lat + " "+bs.lon) +
        "</div>"


    return (lastName);
}

export function createKanCollapsed(bs, i, type, text, text1, text2) {


    var t = "<p align=\"left\">Шифр: " + bs.shifrKan + "<br>Номер телефона: " + bs.lineKan + ((text == undefined) ? "" : "<br>" + text);


    var lastName = document.createElement('div');
    lastName.innerHTML = "<table style=\"margin-top: 0px;\"><tr>" +
        "<td style=\"vertical-align: middle\"><table border=1 height=\"auto\"  style=\"margin-top: 0px;\"><tr>" +
        "<td><font size=\"3px\">" + ((type == 2 || (type == 3)) ? text1 : "&nbsp;&nbsp;&nbsp;") + "</font></td>" +
        "<td><font size=\"3px\">" + ((type == 1 || (type == 3)) ? text2 : "&nbsp;&nbsp;&nbsp;") + "</font></td></tr></table></td><td style=\"vertical-align: middle\">" +
        "<div id = \"bsh" + i + "\" style=\"margin-left: 20px; margin-right:20px\" onclick=\"" +
        "if(document.getElementById('kanb" + i + "').style.display == 'none'){" +
        "document.getElementById('kanb" + i + "').style.display = 'block'" +
        "}else{" +
        "document.getElementById('kanb" + i + "').style.display = 'none'" +
        "}" +
        "\">" + t + "</div></td></tr></table>" +
        "<div id = \"kanb" + i + "\" style=\"margin-left: 20px; margin-right:20px; display: none\">" +
        "<p><span class=\"fieldName\">Шифр: </span>" + bs.shifrKan +
        "<br><span class=\"fieldName\">Номер телефона: </span>" + bs.lineKan +
        "<p><span class=\"fieldName\">Дата надходження: </span>" + bs.dateComingsKan +
        "<p><span class=\"fieldName\">Дата початку контролю: </span>" + bs.dateBeginKan +
        "<br><span class=\"fieldName\">Дата кінця контролю: </span>" + bs.dateEndKan +
        "<p><span class=\"fieldName\">Адреса: </span>" + bs.addressKan +
        "<br><span class=\"fieldName\">Місце роботи: </span>" + bs.jobKan +
        "<p><span class=\"fieldName\">Опис: </span>" + bs.descKan +
        "</div>"


    return (lastName);
}

export function createChecker(){
    var checkbox1 = document.createElement('input');
    checkbox1.type = "checkbox";
    checkbox1.name = "name";
    checkbox1.value = "value";
    checkbox1.className = "checker";
    return checkbox1
}

export function createCheckerLabel(value, html){
    var label1 = document.createElement('label')
                label1.htmlFor = html;
                label1.appendChild(document.createTextNode(value));
                return label1
}

export function createCheckerInput(){
    var input = document.createElement('input');
                input.type = "text";
                input.name = "name";
                input.value = "";
                input.placeholder = "Опис зв\'язку"
                input.className = "input-text";
                return input
}

export const showError = (e) => {
    Swal.fire({
      title: e,
      icon: "error",
      showDenyButton: false,
      showCancelButton: false,
      confirmButtonText: 'ОК',
      denyButtonText: 'Оновити',
      background: '#2B2B2B',
      color: '#FFF'
    }).then((result) => {
    })
  }